import React from 'react';
import { Outlet } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import { organizationSchema, churchSchema, websiteSchema } from '@/seo/schemas';

// Global JSON-LD that should appear on every public page.
// Page-level <Seo /> components add page-specific schemas on top of these.
const GLOBAL_LD = [organizationSchema(), churchSchema(), websiteSchema()];

export default function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-moj-cream">
      <Helmet>
        {GLOBAL_LD.map((obj) => {
          const t = obj && obj['@type'];
          const typeKey = Array.isArray(t) ? t.join('-') : t || 'schema';
          return (
            <script key={`global-ld-${typeKey}`} type="application/ld+json">
              {JSON.stringify(obj)}
            </script>
          );
        })}
      </Helmet>
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
